export default __webpack_public_path__ + "static/media/mg-icon.fe6fc1e5.webp";